var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app",class:`brand-${_vm.$brand.id}`,attrs:{"id":"app"}},[(_vm.showSiteNav)?_c('PCNavbar',{attrs:{"selectIndex":_vm.activeNavIndex}}):_vm._e(),_c('router-view'),(_vm.showSiteFooter)?_c('CallMe'):_vm._e(),(_vm.showSiteFooter)?_c('MobileCallme'):_vm._e(),_c('BackTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }